import { ReduxStore } from 'store/types';

function uploadUrl(state: ReduxStore): string | null {
  return state.image.upload.url;
}

export default uploadUrl;
